// Configuration du menu affiché aux professeurs — labels, routes, icônes.
// Même forme que user_menu.js, consommée par les mêmes composants (Navbarfooter, DesktopSidebar, Drawer).
const profMenu = [
    {
        path: '/espace-professeur/vue-ensemble',
        label: "Vue d'ensemble",
        icon: 'home',
        isActive: (pathname) => pathname.startsWith('/espace-professeur/vue-ensemble'),
    },
    {
        path: '/espace-professeur/equipes',
        label: 'Équipes',
        icon: 'teams',
        isActive: (pathname) => pathname.startsWith('/espace-professeur/equipes'),
    },
    {
        path: '/espace-professeur/classement',
        label: 'Classement',
        icon: 'trophy',
        isActive: (pathname) => pathname.startsWith('/espace-professeur/classement'),
    },
    {
        path: '/espace-professeur/actualites',
        label: 'Actualités',
        icon: 'video',
        isActive: (pathname) => pathname.startsWith('/espace-professeur/actualites'),
    },
    {
        path: '/espace-professeur/administratif',
        label: 'Administratif',
        icon: 'admin',
        isActive: (pathname) => pathname.startsWith('/espace-professeur/administratif'),
    },
];

export default profMenu;
